import axios from './axiosService';

export default {
  async getEvents(form) { // MLD-8192
    const options = {
      params: form,
    }
    const {data} = await axios.get(`/api/nylas/events`, options);
    return data;
  },
  getStatusCodes() { // MLD-8192
    return [
      {
        id: 'message.created',
        text: 'Delivered',
        color: 'blue lighten-3',
        icon: 'fa-hourglass-start',
      },
      {
        id: 'message.created.truncated',
        text: 'Delivered',
        color: 'blue lighten-3',
        icon: 'fa-hourglass-start',
      },
      {
        id: 'message.send_success',
        text: 'Delivered',
        color: 'blue lighten-3',
        icon: 'fa-hourglass-start',
      },
      {
        id: 'message.send_success.truncated',
        text: 'Delivered',
        color: 'blue lighten-3',
        icon: 'fa-hourglass-start',
      },
      {
        id: 'message.updated',
        text: 'Updated',
        color: 'blue lighten-3',
        icon: 'fa-fw',
      },
      {
        id: 'message.updated.truncated',
        text: 'Updated',
        color: 'blue lighten-3',
        icon: 'fa-fw',
      },
      {
        id: 'message.opened',
        text: 'Opened',
        color: 'light-green lighten-1',
        darkMode: true,
        icon: 'fa-envelope-open',
      },
      {
        id: 'message.link_clicked',
        text: 'Clicked',
        color: 'success',
        darkMode: true,
        icon: 'fa-hand-pointer',
      },
      {
        id: 'message.bounce_detected',
        text: 'Bounced',
        color: 'error',
        darkMode: true,
        icon: 'fa-exclamation-triangle',
      },
      {
        id: 'message.send_failure',
        text: 'Failed',
        color: 'error',
        darkMode: true,
        icon: 'fa-exclamation-triangle',
      },
      {
        id: 'message.send_failure.truncated',
        text: 'Failed',
        color: 'error',
        darkMode: true,
        icon: 'fa-exclamation-triangle',
      },
      {
        id: 'message.send_failed',
        text: 'Failed',
        color: 'error',
        darkMode: true,
        icon: 'fa-exclamation-triangle',
      },
    ]
  },
  getEventTypes() { // MLD-8192
    return [
      'grant.created',
      'grant.updated',
      'grant.deleted',
      'grant.expired',
      'calendar.created',
      'calendar.updated',
      'calendar.deleted',
      'event.created',
      'event.updated',
      'event.deleted',
      'booking.created',
      'booking.pending',
      'booking.rescheduled',
      'booking.cancelled',
      'booking.reminder',
      'notetaker.created',
      'notetaker.updated',
      'notetaker.meeting_state',
      'notetaker.media',
      'notetaker.deleted',
      'message.created',
      'message.created.truncated',
      'message.updated',
      'message.updated.truncated',
      'message.send_success',
      'message.send_success.truncated',
      'message.send_failure',
      'message.send_failure.truncated',
      'message.send_failed',
      'message.bounce_detected',
      'message.opened',
      'message.link_clicked',
      'thread.replied',
      'message.opened.legacy',
      'message.link_clicked.legacy',
      'thread.replied.legacy',
      'message.intelligence.order',
      'message.intelligence.tracking',
      'message.intelligence.return',
      'folder.created',
      'folder.updated',
      'folder.deleted',
      'contact.updated',
      'contact.deleted'
    ];
  },
  getProviders() {
    return [
      {id: 'Exchange', name: 'Exchange'},
      {id: 'Google', name: 'Google'},
      {id: 'Microsoft 365', name: 'Microsoft 365'},
    ];
  },
  async getContacts(params = {}) {
    const options = {
      params,
    };
    return axios.get(`/api/nylas/contacts`, options)
      .then(response => response.data)
      .catch(err => {
        return [];
      })
  }
}
